import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../styles/Users.css";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // const [editUserId, setEditUserId] = useState(null);
  // const [editFormData, setEditFormData] = useState({
  //   name: "",
  //   username: "",
  //   email: "",
  //   isAdmin: false,
  // });

  const navigate = useNavigate();

  // const tableRef = useRef(null);

  // Fetch users data
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users`, {
          credentials: "include",
        });
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message || "Failed to fetch users");
        }

        toast.success("Successfully fetched all users");

        setUsers(data);
        console.log("User data:", data);
      } catch (err) {
        toast.error(err.message || "Failed to fetch users");
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  if (loading) {
    return <div>Loading users...</div>;
  }

  return (
    <div className="users__container">
      <h2>Users</h2>
      {!users || users.length === 0 ? (
        <h2>No Users Found.</h2>
      ) : (
        <div className="users__table--wrappper">
          <table className="users__table">
            <thead className="users__table--header">
              <tr key={users.id}>
                <th data-label="Name">Name:</th>
                <th data-label="Username">UserName:</th>
                <th data-label="Email">Email:</th>
                <th data-label="isAdmin">isAdmin:</th>
              </tr>
            </thead>
            <tbody className="users__table--body">
              {users
                .sort((a, b) => b.name.localeCompare(a.name))
                .map((user) => (
                  <tr
                    key={user._id}
                    onClick={() => navigate(`/dashboard/users/${user._id}`)}
                    className="users__table--row"
                  >
                    <td data-label="Name">{user.name}</td>
                    <td data-label="UserName">{user.username}</td>
                    <td data-label="Email">{user.email}</td>
                    <td data-label="isAdmin">{user.isAdmin ? "Yes" : "No"}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
